export default "__VITE_ASSET__C7X0HbWd__"